const STORAGE_KEY = 'gi_calibrated_range';
export function loadCalibratedRange(): ReadonlySet<string> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const arr: unknown = JSON.parse(raw);
    if (!Array.isArray(arr)) return null;
    return new Set(arr.filter((x): x is string => typeof x === 'string'));
  } catch {
    return null;
  }
}
export function saveCalibratedRange(cellIds: ReadonlySet<string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...cellIds]));
  } catch {
  }
}
export function clearCalibratedRange(): void {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}
